import React from 'react'
import PropTypes from 'prop-types'
import { ORDER_SUB_STATUS, workOrder as workOrderType } from 'types'
import { SPECIAL_ACTIONS_PARTIAL } from '../constants'
import { getSpecialActionsPartial } from '../specialActions'
import AcceptDeclineForm from './AcceptDeclineForm'
import ReschedulingActionsForm from './ReschedulingActionsForm'
import InProgressActionsForm from './InProgressActionsForm'
import AddTechCommentsForm from './AddTechCommentsForm'

const propTypes = {
  workOrder: workOrderType,
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  onReschedule: PropTypes.func.isRequired,
  onInProgressResetEta: PropTypes.func.isRequired,
  onInProgressChangeStatus: PropTypes.func.isRequired,
  onAddTechComments: PropTypes.func.isRequired,
  onRefreshWorkOrder: PropTypes.func.isRequired,
}
const defaultProps = {}

// Renders the one special actions partial that applies to the work order's
// current status (see getSpecialActionsPartial), or nothing.
function SpecialActionsForm({
  workOrder,
  onAccept,
  onDecline,
  onReschedule,
  onInProgressResetEta,
  onInProgressChangeStatus,
  onAddTechComments,
  onRefreshWorkOrder,
}) {
  const partial = getSpecialActionsPartial(workOrder)
  if (!partial) return null

  const renderPartial = () => {
    switch (partial) {
      case SPECIAL_ACTIONS_PARTIAL.ACCEPT_DECLINE:
        return (
          <AcceptDeclineForm
            workOrder={workOrder}
            onAccept={onAccept}
            onDecline={onDecline}
          />
        )
      case SPECIAL_ACTIONS_PARTIAL.RESCHEDULING:
        return (
          <ReschedulingActionsForm
            onDecline={onDecline}
            onReschedule={onReschedule}
            onAddTechComments={onAddTechComments}
            onRefreshWorkOrder={onRefreshWorkOrder}
          />
        )
      case SPECIAL_ACTIONS_PARTIAL.IN_PROGRESS:
        // Reset ETA is hidden while the estimate is pending approval.
        return (
          <InProgressActionsForm
            currentStatus={workOrder.orderStatus}
            canResetEta={
              workOrder.orderSubStatus !==
              ORDER_SUB_STATUS.PENDING_ESTIMATE_APPROVAL
            }
            onResetEta={onInProgressResetEta}
            onChangeStatus={onInProgressChangeStatus}
            onAddTechComments={onAddTechComments}
            onRefreshWorkOrder={onRefreshWorkOrder}
          />
        )
      case SPECIAL_ACTIONS_PARTIAL.ADD_TECH_COMMENTS:
        return (
          <AddTechCommentsForm
            onAddTechComments={onAddTechComments}
            onRefreshWorkOrder={onRefreshWorkOrder}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className="manager-order-show__panel card-styling">
      {renderPartial()}
    </div>
  )
}

SpecialActionsForm.propTypes = propTypes
SpecialActionsForm.defaultProps = defaultProps

export default SpecialActionsForm
